<template>
  <v-checkbox
    style="margin-top: -5px"
    @change="(val) => $emit('input', val)"
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    hide-details
  />
</template>

<script>
export default {
  inheritAttrs: false,
  props: ['value'],
  data: () => ({}),
  methods: {},
}
</script>
